<nwm-menu />
<div class="content">
  <div class="main">
    <div class="row my-4">
      <div class="col-xxl-10 offset-xxl-1">

        <div class="row my-4">
          <div class="col-lg-6"><h1>Grants to all Impact Areas</h1></div>
          <div class="col-lg-6 text-right">
            <div class="search">
              <input type="text" name="keyword" id="keyword" value="" placeholder="Search by Impact Area" [(ngModel)]="filterText" (keyup.enter)="filterImpacts()" class="form-control mt-1">
              <i class="search-icon fa" tabindex="0" [ngClass]="curentFilterText === '' || curentFilterText !== filterText? 'fa-search' : 'fa-close'" (click)="(curentFilterText === '' || curentFilterText !== filterText) ? filterImpacts() : clearTextFilter()"></i>
            </div>
            <a (click)="export()" tabindex="0" class="export-btn d-print-none">Export</a>
          </div>
        </div>
        @if (impactsLoaded) {
          <div class="row">
            <div class="col-12">
              <div class="scrollable-wrap">
                <div class="scrollable">
                  <div class="scrollable-button left"></div>
                  <div class="scrollable-button"></div>
                  <table width="100%" class="NWMtable sticky_header table table-striped mb-0">
                    <thead>
                      <tr>
                        <td role="button" (click)="toggleSort('CharityType')" class="sortable">
                          <span>Charity Category</span>
                          <i class="fa ml-2" [ngClass]="sortField === 'CharityType' ? (sortDir<0 ? 'fa-sort-asc' : 'fa-sort-desc') : ''" aria-hidden="true"></i>
                        </td>
                        <td width="140" role="button" class="text-right sortable" (click)="toggleSort('AmountCAD')">
                          <span>Amount</span>
                          <i class="fa ml-2" [ngClass]="sortField === 'AmountCAD' ? (sortDir<0 ? 'fa-sort-asc' : 'fa-sort-desc') : ''" aria-hidden="true"></i>
                        </td>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td class="text-left align-middle">
                          <b>Total Grants</b>
                        </td>
                        <td class="text-right align-middle">
                          <b>{{total | currency:'USD': 'symbol':'1.0-0' | minusSignToParens}}</b>
                        </td>
                      </tr>
                      @if (pagedImpacts) {
                        <ng-container *ngTemplateOutlet="dataList" />
                      }
                    </tbody>
                  </table>
                </div>
              </div>
              <div class="form-inline float-right mb-4">
                <div class="form-group pt-4">
                  <label for="pageSize" class="font-weight-bold">Rows Displayed</label>
                  <select [(ngModel)]="pageSize" name="pageSize" class="form-control mx-sm-3" id="pageSize" (ngModelChange)="filterImpacts()">
                    <option  [value]="0" [selected]="!pageSize">All</option>
                    @for (o of pageOptions; track o) {
                      <option [value]="o" [selected]="pageSize  === o">{{o}}</option>
                    }
                  </select>
                </div>
                @if (totalPages > 1) {
                  <ngb-pagination [collectionSize]="filteredImpacts.length"
                    [(page)]="page" [maxSize]="2" (pageChange)="setPage()"
                    class="pagination pt-4"
                    [pageSize]="pageSize"
                    [boundaryLinks]="true">
                    <ng-template ngbPaginationFirst>First</ng-template>
                    <ng-template ngbPaginationPrevious>Previous</ng-template>
                    <ng-template ngbPaginationNext>Next</ng-template>
                    <ng-template ngbPaginationLast>Last</ng-template>
                  </ngb-pagination>
                }
              </div>
            </div>
          </div>
        }

      </div>
    </div>
  </div>
</div>

<ng-template #dataList>
  @if (pagedImpacts) {
    @for (row of pagedImpacts; track row) {
      <tr>
        <td class="text-left align-middle">
          <a routerLink="/pgf/impact/{{encodeUriComponent(row.CharityType)}}">{{row.CharityType}}</a>
        </td>
        <td class="text-right align-middle">
          {{row.AmountCAD | currency:'USD': 'symbol':'1.0-0' | minusSignToParens}}
        </td>
      </tr>
    }
  }
</ng-template>
